import React from "react";
import classnames from "classnames";

const WineItem = ({ wine, setWineModalInfo }) => {
  const {
    glass_price,
    soldout,
    bottle_price,
    Item_name: item,
    item_price,
    long_description,
    small_description,
    wine: wineField,
  } = wine;
  const relatedWineName = wineField?.wine_name || wineField?.fields?.wineName;
  const hyphenWineName =
    relatedWineName && relatedWineName.split(" ").join("-").toLowerCase();
  const renderItemPrice =
    glass_price || bottle_price
      ? `${bottle_price} / ${glass_price || "bottle only"}`
      : item_price;

  return (
    <article
      className={classnames("menu-item", {
        "menu-item--soldout": soldout,
        soldout: soldout,
      })}
    >
      <div className="menu-item__header">
        <h3 className="menu-item__name">{item}</h3>
        <span className="menu-item__price">
          {soldout ? "sold out" : renderItemPrice}
        </span>
      </div>
      {small_description && (
        <p className="menu-item__note">{small_description}</p>
      )}
      {long_description && (
        <p className="menu-item__desc">{long_description}</p>
      )}
      {hyphenWineName && (
        <div className="styled-link menu-item__link">
          <span
            className="m-t-10"
            onClick={() => setWineModalInfo(wineField.fields || wineField)}
          >
            learn more
          </span>
        </div>
      )}
    </article>
  );
};

export default WineItem;
